export const layersKeys = {
  prefix: 'layers',
  list: (articleKey: string, { password }: { password?: string | null }) => [
    layersKeys.prefix,
    articleKey,
    'list',
    { password },
  ],
  detail: (id: string, password?: string | null) => [layersKeys.prefix, 'detail', id, { password }],
  update: (id: string, password?: string | null) => [...layersKeys.detail(id, password), 'update'],
  delete: (id: string, password?: string | null) => [...layersKeys.detail(id, password), 'delete'],
  merge: (id: string) => [...layersKeys.detail(id), 'merge'],
  revision: (layerId: string, id: string) => [...layersKeys.detail(layerId), 'revisions', id],
}
